import {ADDRESS, BKK, synonymAddress, synonymAddressForEmployee} from './utils-interface';
import {IsEmptyValue} from './utils';

export function formatAddress(address: ADDRESS): string {
  return (address.street_no ? `${address.street_no} ` : '') +
    (address.moo_no ? `หมู่ ${address.moo_no} ` : '') +
    (address.building ? `อาคาร${address.building} ` : '') +
    (address.room_no ? `ห้อง ${address.room_no} ` : '') +
    (address.floor_no ? `ชั้น ${address.floor_no} ` : '') +
    (address.village_name ? `หมู่บ้าน${address.village_name} ` : '') +
    (address.soi ? `ซอย${address.soi} ` : '') +
    (address.alley ? `ตรอก${address.alley} ` : '') +
    (address.lane ? `แยก ${address.lane} ` : '') +
    (address.road ? `ถนน${address.road} ` : '') +
    (address.sub_district ? `${BKK.includes(address.province) ? 'แขวง' : 'ตำบล'}${address.sub_district} ` : '') +
    (address.district ? `${BKK.includes(address.province) ? 'เขต' : 'อำเภอ'}${address.district} ` : '') +
    (address.province ? `${address.province} ` : '') +
    (address.postal_code ? `${address.postal_code} ` : '');
}

export function replaceAddressSynonym(key: string, value: string): string {
  if (value && value !== '') {
    const replaceArray = synonymAddress[key];
    let replacedString = value === '-' ? value.replace(/-/, '') : value;
    if (replacedString !== '') {
      replaceArray?.map((_, index: number) => {
        if (value.split(replaceArray[index])[0] === '') { // replace only first word in sentense.
          replacedString = replacedString.replace(replaceArray[index], '');
        }
      });
    }
    return replacedString;
  } else {
    return value;
  }
}

// todo manual fixed for replace synonym employee address
export function replaceAddressSynonymForEmployee(key: string, value: string): string {
  if (value && !IsEmptyValue(value)) {
    const replaceArray = synonymAddressForEmployee[key];
    let replacedString = value.toString();
    replaceArray?.map((_, index: number) => {
      if (value.toString().split(replaceArray[index])[0] === '') { // replace only first word in sentense.
        replacedString = replacedString.replace(replaceArray[index], '');
      }
    });
    return replacedString;
  } else {
    return value;
  }
}
